<template>
  <v-dialog
    :id="id"
    class="cs-dialog"
    v-model="dialog"
    :fullscreen="fullscreen"
    :opacity="opacity"
    :transition="transition"
    :scrollable="scrollable"
    :persistent="persistent"
    :width="width"
    :max-width="maxWidth"
  >
    <template v-slot:activator="{ props: activatorProps }">
      <slot name="activator" :activatorProps="activatorProps"></slot>
    </template>

    <v-card :id="bodyId" v-if="fullscreen">
      <v-toolbar
        v-if="fullscreenDialogHeader"
        flat
        :color="whiteHeader ? 'white' : 'accent white--text'"
        class="dialog-header"
      >
        <slot name="fullscreen-dialog-header"></slot>
      </v-toolbar>
      <div class="dialog-alert">
        <cs-alert dialog></cs-alert>
      </div>
      <v-card-text>
        <slot name="fullscreen-dialog-body"></slot>
      </v-card-text>
    </v-card>
    <v-card :id="bodyId" v-else>
      <v-card-title v-if="dialogTitle" class="dialog-title">
        <slot name="dialog-title"></slot>
      </v-card-title>
      <v-toolbar v-if="dialogHeader" dense flat color="accent white--text" class="dialog-header">
        <slot name="dialog-header"></slot>
      </v-toolbar>
      <div class="dialog-alert">
        <cs-alert dialog></cs-alert>
      </div>
      <v-card-text v-if="dialogBodyText">
        <slot name="dialog-body-text"></slot>
      </v-card-text>
      <div v-else>
        <slot name="dialog-body"></slot>
      </div>
      <v-card-actions v-if="dialogActions" class="dialog-actions">
        <slot name="dialog-actions"></slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { CSBase } from '@complispace/cs-design-system';

export default {
  name: 'FullScreenDialog',

  extends: CSBase,

  emits: ['update:modelValue'],
  props: {
    id: { type: String, required: false },
    bodyId: { type: String, required: false },
    modelValue: { type: Boolean, required: true },
    fullscreen: { type: Boolean, required: false },
    opacity: { type: String, required: false },
    transition: { type: String, required: false, default: 'slide-y-reverse-transition' },
    scrollable: { type: Boolean, required: false },
    width: { type: String, required: false },
    whiteHeader: { type: Boolean, required: false },
    maxWidth: { type: String, required: false },
    persistent: { type: Boolean, required: false }
  },

  computed: {
    dialog: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      }
    },
    dialogTitle() {
      return !!this.$slots['dialog-title'];
    },

    dialogHeader() {
      return !!this.$slots['dialog-header'];
    },

    dialogBodyText() {
      return !!this.$slots['dialog-body-text'];
    },

    dialogActions() {
      return !!this.$slots['dialog-actions'];
    },

    fullscreenDialogHeader() {
      return !!this.$slots['fullscreen-dialog-header'];
    }
  },

  watch: {
    modelValue(newVal) {
      if (newVal || !this.dialog) {
        this.clearAlert();
      }
    }
  }
};
</script>

<style scoped>
.dialog-alert {
  position: relative;
}

.dialog-header {
  max-height: 64px;
  padding: 4px 24px 0px;
}

.dialog-actions {
  display: block;
  text-align: right;
}
</style>
